<template>
    <b-form @submit.prevent="submit">

        <b-alert variant="warning" fade :show="showWarningInvalidSortingLocation" class="p-2">
            Onjuiste legplaats. Probeer het opnieuw.<br/>
        </b-alert>
        <b-alert variant="danger" fade :show="showError" class="p-2">
            Fout bij het opslaan van de legplaats.
            Neem contact op met <a href="mailto:info@omnistock.nl">OmniStock</a>.
        </b-alert>

        <p v-if="storageLocationIdentifier" :data-identifier="storageLocationIdentifier">
            Plaats <span v-html="articleSingularOrPlural"/> in legplaats <strong>{{storageLocationDisplayName}}</strong>
        </p>
        <p v-else>
            Plaats <span v-html="articleSingularOrPlural"/> in een <strong>lege legplaats</strong>
        </p>

        <b-input ref="valueInput"
                 v-model.trim="scanValue"
                 :key="isProcessing"
                 :disabled="isProcessing"
                 :inputmode="inputFocusedManually ? 'text' : 'none'"
                 @click="inputFocusedManually = true"
                 type="text"
                 class="d-inline-block mr-2"
                 style="width:230px;"
                 placeholder="Legplaats"
                 required
                 autofocus
                 autocomplete="off"
        />
        <b-button variant="primary" type="submit" :disabled="isProcessing">
            <span v-if="!isProcessing">Scan</span>
            <font-awesome-icon v-else icon="spinner" spin />
        </b-button>
    </b-form>
</template>

<script>
import {UsesProductProcessApi} from "./UsesProductProcessApi";
import {getLocationPropertyValue} from "../../../helpers/locations";
export default {
    extends: UsesProductProcessApi,
    name: "SortingLocationScan",

    props: {
        ...UsesProductProcessApi.props,
        productIdentifier: {required: true, type: String},
        quantity: {default: 1},
        productState: {required: false},
        dispatchRequest: {required: true},
        storageLocationIdentifier: {required: true, type: String},
        storageLocationDisplayName: {required: true, type: String},
        specialProcessingStepsResult: {required: false},
    },

    data() {
        return {
            isProcessing: false,
            showWarningInvalidSortingLocation: false,
            showError: false,
            scanValue: '',
            inputFocusedManually: false,
            refocusInterval: setInterval(() => this.$refs['valueInput']?.focus(), 500),
        }
    },

    computed: {
        articleSingularOrPlural() {
            return (this.quantity === 1)
                ? 'het artikel'
                : `<u>${this.quantity} artikelen</u>`
        },
    },

    mounted() {
        const autofill = getLocationPropertyValue(this.location.location_properties, 'processProduct.autofillStorageLocation')
        if (autofill !== 0) {
            this.scanValue = this.storageLocationIdentifier
            if (autofill === 2) {
                this.submit()
            }
        }
    },

    beforeDestroy() {
        clearInterval(this.refocusInterval)
    },

    methods: {
        submit() {
            if (this.isProcessing) {
                return
            }

            this.isProcessing = true
            this.showWarningInvalidSortingLocation = false
            this.showError = false

            if (this.storageLocationIdentifier && this.scanValue !== this.storageLocationIdentifier) {
                this.showWarningInvalidSortingLocation = true
                this.scanValue = ''
                this.isProcessing = false
                return
            }

            const postData = {
                ...this.postData,
                quantity: this.quantity,
                dispatch_request_id: this.dispatchRequest.id,
                product_state: this.productState, // Only used for 'return' process, ignored for other process types
                extra_processing_steps: this.specialProcessingStepsResult,
            }

            this.$http.post(`/api/rest/locations/${this.location.location_type.identifier}/${this.location.identifier}/storage-locations/${this.storageZoneIdentifier}/${this.scanValue}/process-product/${this.processType}/${this.productIdentifier}`, postData)
                .then(response => {
                    clearInterval(this.refocusInterval)
                    this.$emit('success', response.data)
                })
                .catch(e => {
                    try {
                        console.log(e)
                        if (e.response.data.errors[0].message === 'Storage location not found') {
                            this.showWarningInvalidSortingLocation = true
                            return
                        }
                    } catch (e) {
                        // don't crash
                    }

                    this.showError = true
                })
                .then(() => {
                    this.isProcessing = false
                })
        }
    },

    watch: {
        scanValue(value) {
            const regex = this.$store.getters.getFrontendParameterValue('process-products-sort', 'storage-location-auto-submit-regex')
            if (!regex) {
                return;
            }

            if (new RegExp(regex, 'i').test(value)) {
                this.submit()
            }
        },
    },
}
</script>

<style scoped>

</style>
